<template>
  <div>
    <div ref="chartContainer" class="pa-3" style="width:96%; height:90%"></div>
  </div>

</template>

<script>
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';

Exporting(Highcharts);
ExportData(Highcharts);

export default {
  name: 'BarForSingleSearch',
  props: ["tdata"],
  data() {
    return {
      chart: null
    };
  },

  computed: {
    textEvidenceColor() {
      return this.$store.state.textEvidenceColor;
    },
    figureEvidenceColor() {
      return this.$store.state.figureEvidenceColor;
    },
    experimentEvidenceColor() {
      return this.$store.state.experimentEvidenceColor;
    },
    cohortEvidenceColor() {
      return this.$store.state.cohortEvidenceColor;
    },
  },
  methods: {
    renderChart() {
      if (!this.tdata || this.tdata.length === 0) {
        return;  // 防止空数据渲染
      }

      const container = this.$refs.chartContainer;
      if (!container) {
        console.warn("Chart container not found.");
        return;
      }

      const sortedData = this.tdata.map(item => {
        return {
          ...item,
          textEvidence: item.text_evidence_count || 0,
          figureEvidence: item.figure_evidence_count || 0,
          experimentEvidence: item.experiment_evidence_count || 0,
          cohortEvidence: item.cohort_evidence_count || 0,
          totalEvidence: item.evidence_total || 0
        };
      }).sort((a, b) => b.totalEvidence - a.totalEvidence).slice(0, 25);

      if (sortedData.length === 0) return;

      const allSameSubstrate = sortedData.every(item => item.substrate === sortedData[0].substrate);

      const categories = sortedData.map(item => {
        if (allSameSubstrate && item.harm_site) {
          return item.harm_site;
        } else {
          const id = item.internal_id || '';
          const parts = id.split('_');
          return parts.length >= 2 ? `${parts[0]}:${parts[1]}` : id;
        }
      });

      const textEvidenceData = sortedData.map(item => ({
        y: item.text_evidence_count,
        id: item.internal_id
      }));

      const figureEvidenceData = sortedData.map(item => ({
        y: item.figure_evidence_count,
        id: item.internal_id
      }));

      const cohortEvidenceData = sortedData.map(item => ({
        y: item.cohort_evidence_count,
        id: item.internal_id
      }));

      const experimentEvidenceData = sortedData.map(item => ({
        y: item.experiment_evidence_count,
        id: item.internal_id
      }));

      if (this.chart) {
        this.chart.destroy();
      }

      Highcharts.chart(container, {
        chart: {
          type: 'column',
          zoomType: 'y',
          spacingTop: 20,
          spacingRight: 10,
          spacingBottom: 10,
          spacingLeft: 10
        },
        title: { text: '' },
        xAxis: {
          categories: categories,
          crosshair: true,
          title: { text: 'Site' },
          labels: { rotation: -45, step: 1 }
        },
        yAxis: {
          title: { text: 'Evidence Count' },
          stackLabels: { enabled: true }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          shadow: false
        },
        tooltip: {
          formatter: function () {
            return `<b>${this.point.id}</b><br/>
                ${this.series.name}: ${this.y}<br/>
                Total: ${this.point.stackTotal}`;
          },
          distance: 30,
          followPointer: true
        },
        plotOptions: {
          column: {
            animation: false,
            stacking: 'normal',
            dataLabels: { enabled: true },
            point: {
              events: {
                click: function () {
                  const base_url = window.location.origin;
                  const itemId = this.options.id;
                  const url = `${base_url}/#/single-search/${itemId}?ptm_type=phosphorylation`;
                  window.open(url, '_blank');
                }
              }
            }
          }
        },
        series: [
          { name: 'Text mining', data: textEvidenceData, color: this.textEvidenceColor },
          { name: 'Figure mining', data: figureEvidenceData, color: this.figureEvidenceColor },
          { name: 'PTMAtlas datasets', data: experimentEvidenceData, color: this.experimentEvidenceColor },
          { name: 'CPTAC datasets', data: cohortEvidenceData, color: this.cohortEvidenceColor }
        ],
        exporting: {
          enabled: true,
          sourceWidth: 800,
          sourceHeight: 600,
          scale: 4,
          buttons: {
            contextButton: {
              x: 10,
              y: -28,
              menuItems: ['downloadPNG',  'downloadSVG']
            }
          }
        }
      });
    }
  },
  watch: {
    tdata: {
      handler() {
        this.$nextTick(() => {
          this.renderChart();
        });
      },
      immediate: true
    }
  }

};
</script>
